/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from './base';

/**
 *
 * @export
 * @interface AdditionalLaborFees
 */
export interface AdditionalLaborFees {
  /**
   *
   * @type {number}
   * @memberof AdditionalLaborFees
   */
  additional_universe_cost: number;
  /**
   *
   * @type {number}
   * @memberof AdditionalLaborFees
   */
  oversample_cost: number;
  /**
   *
   * @type {number}
   * @memberof AdditionalLaborFees
   */
  filter_labor_cost: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const BusinessUnit = {
  Pna: 'pna',
  Embold: 'embold',
} as const;

export type BusinessUnit = (typeof BusinessUnit)[keyof typeof BusinessUnit];

/**
 *
 * @export
 * @enum {string}
 */

export const ClientBudget = {
  Low: 'low',
  Medium: 'medium',
  High: 'high',
} as const;

export type ClientBudget = (typeof ClientBudget)[keyof typeof ClientBudget];

/**
 *
 * @export
 * @enum {string}
 */

export const ClientComplexity = {
  Standard: 'standard',
  High: 'high',
  Ultra: 'ultra',
} as const;

export type ClientComplexity =
  (typeof ClientComplexity)[keyof typeof ClientComplexity];

/**
 *
 * @export
 * @interface ClientName
 */
export interface ClientName {}
/**
 *
 * @export
 * @enum {string}
 */

export const ClientType = {
  Downballot: 'downballot',
  HouseOrStatewide: 'house_or_statewide',
  NationalPacIeAdvocacyOrg: 'national_pac_ie_advocacy_org',
  StateLocalPacIeAdvocacyOrg: 'state_local_pac_ie_advocacy_org',
  Corporate: 'corporate',
} as const;

export type ClientType = (typeof ClientType)[keyof typeof ClientType];

/**
 *
 * @export
 * @interface DealName
 */
export interface DealName {}
/**
 *
 * @export
 * @interface DistrictDemoData
 */
export interface DistrictDemoData {
  /**
   *
   * @type {DistrictOutput}
   * @memberof DistrictDemoData
   */
  district: DistrictOutput;
  /**
   *
   * @type {number}
   * @memberof DistrictDemoData
   */
  registered_voters: number;
  /**
   *
   * @type {number}
   * @memberof DistrictDemoData
   */
  max_sample_size: number;
  /**
   *
   * @type {number}
   * @memberof DistrictDemoData
   */
  dem_primary_max_sample_size: number;
  /**
   *
   * @type {number}
   * @memberof DistrictDemoData
   */
  percent_white: number;
  /**
   *
   * @type {number}
   * @memberof DistrictDemoData
   */
  percent_black: number;
  /**
   *
   * @type {number}
   * @memberof DistrictDemoData
   */
  percent_hispanic: number;
  /**
   *
   * @type {number}
   * @memberof DistrictDemoData
   */
  percent_aapi: number;
}
/**
 *
 * @export
 * @interface DistrictInput
 */
export interface DistrictInput {
  /**
   *
   * @type {DistrictType}
   * @memberof DistrictInput
   */
  district_type: DistrictType;
  /**
   *
   * @type {string}
   * @memberof DistrictInput
   */
  name: string;
  /**
   *
   * @type {State}
   * @memberof DistrictInput
   */
  state: State;
}

/**
 *
 * @export
 * @interface DistrictOutput
 */
export interface DistrictOutput {
  /**
   *
   * @type {DistrictType}
   * @memberof DistrictOutput
   */
  district_type: DistrictType;
  /**
   *
   * @type {string}
   * @memberof DistrictOutput
   */
  name: string;
  /**
   *
   * @type {State}
   * @memberof DistrictOutput
   */
  state: State;
  /**
   *
   * @type {string}
   * @memberof DistrictOutput
   */
  id: string;
}

/**
 *
 * @export
 * @interface DistrictQuery
 */
export interface DistrictQuery {
  /**
   *
   * @type {State}
   * @memberof DistrictQuery
   */
  state: State;
  /**
   *
   * @type {DistrictType}
   * @memberof DistrictQuery
   */
  district_type?: DistrictType | null;
  /**
   *
   * @type {string}
   * @memberof DistrictQuery
   */
  name?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const DistrictType = {
  State: 'State',
  City: 'City',
  ResidenceCity: 'Residence City',
  VotingCity: 'Voting City',
  County: 'County',
  ZipCode: 'Zip Code',
  Congressional: 'Congressional',
  StateLegUpper: 'State Leg Upper',
  StateLegLower: 'State Leg Lower',
  TownDistrict: 'Town District',
  SchoolDistrict: 'School District',
  CountyCommissionerSupervisor: 'County Commissioner / Supervisor',
  CityCouncilCommissioner: 'City Council / Commissioner',
  BoardOfEdDistrict: 'Board of Ed District',
  TownWard: 'Town Ward',
  CitySchoolDistrict: 'City School District',
  SchoolSubdistrict: 'School Subdistrict',
  UnifiedSchoolDistrict: 'Unified School District',
  UnifiedSchoolSubdistrict: 'Unified School Subdistrict',
  CountyBoardOfEdSubdistrict: 'County Board of Ed Subdistrict',
  CountyBoardOfEdDistrict: 'County Board of Ed District',
  CityWard: 'City Ward',
  SchoolBoard: 'School Board',
  CountyLegislature: 'County Legislature',
  Nationwide: 'Nationwide',
  Other: 'Other',
} as const;

export type DistrictType = (typeof DistrictType)[keyof typeof DistrictType];

/**
 *
 * @export
 * @interface Factor
 */
export interface Factor {
  /**
   *
   * @type {FactorType}
   * @memberof Factor
   */
  factor_type: FactorType;
  /**
   *
   * @type {Array<Weight>}
   * @memberof Factor
   */
  weights: Array<Weight>;
}

/**
 *
 * @export
 * @interface FactorBreakdowns
 */
export interface FactorBreakdowns {
  /**
   *
   * @type {IndividualFactorValue}
   * @memberof FactorBreakdowns
   */
  client_budget: IndividualFactorValue;
  /**
   *
   * @type {IndividualFactorValue}
   * @memberof FactorBreakdowns
   */
  sample_size_budget: IndividualFactorValue;
  /**
   *
   * @type {IndividualFactorValue}
   * @memberof FactorBreakdowns
   */
  questions_budget: IndividualFactorValue;
  /**
   *
   * @type {IndividualFactorValue}
   * @memberof FactorBreakdowns
   */
  client_complexity: IndividualFactorValue;
  /**
   *
   * @type {IndividualFactorValue}
   * @memberof FactorBreakdowns
   */
  research_complexity: IndividualFactorValue;
  /**
   *
   * @type {IndividualFactorValue}
   * @memberof FactorBreakdowns
   */
  questions_labor: IndividualFactorValue;
  /**
   *
   * @type {IndividualFactorValue}
   * @memberof FactorBreakdowns
   */
  universe_type: IndividualFactorValue;
}
/**
 *
 * @export
 * @enum {string}
 */

export const FactorType = {
  ResearchComplexity: 'research_complexity',
  ClientComplexity: 'client_complexity',
  ClientBudget: 'client_budget',
  SampleSize: 'sample_size',
  NumberOfQuestions: 'number_of_questions',
  UniverseType: 'universe_type',
} as const;

export type FactorType = (typeof FactorType)[keyof typeof FactorType];

/**
 *
 * @export
 * @enum {string}
 */

export const FirewallSide = {
  Candidate: 'Candidate',
  Exempt: 'Exempt',
  IndependentExpenditure: 'Independent Expenditure',
  Above: 'Above',
  Unknown: 'Unknown',
} as const;

export type FirewallSide = (typeof FirewallSide)[keyof typeof FirewallSide];

/**
 *
 * @export
 * @interface GetQuoteFilter
 */
export interface GetQuoteFilter {
  [key: string]: any;

  /**
   *
   * @type {DealName}
   * @memberof GetQuoteFilter
   */
  deal_name?: DealName;
  /**
   *
   * @type {ClientName}
   * @memberof GetQuoteFilter
   */
  client_name?: ClientName;
  /**
   *
   * @type {GetQuoteFilterBusinessUnit}
   * @memberof GetQuoteFilter
   */
  business_unit?: GetQuoteFilterBusinessUnit;
  /**
   *
   * @type {GetQuoteFilterClientType}
   * @memberof GetQuoteFilter
   */
  client_type?: GetQuoteFilterClientType;
}
/**
 *
 * @export
 * @interface GetQuoteFilterBusinessUnit
 */
export interface GetQuoteFilterBusinessUnit {}
/**
 *
 * @export
 * @interface GetQuoteFilterClientType
 */
export interface GetQuoteFilterClientType {}
/**
 *
 * @export
 * @interface GetQuoteV2Filter
 */
export interface GetQuoteV2Filter {
  [key: string]: any;

  /**
   *
   * @type {DealName}
   * @memberof GetQuoteV2Filter
   */
  deal_name?: DealName;
  /**
   *
   * @type {ClientName}
   * @memberof GetQuoteV2Filter
   */
  client_name?: ClientName;
  /**
   *
   * @type {GetQuoteFilterBusinessUnit}
   * @memberof GetQuoteV2Filter
   */
  business_unit?: GetQuoteFilterBusinessUnit;
  /**
   *
   * @type {GetQuoteFilterClientType}
   * @memberof GetQuoteV2Filter
   */
  client_type?: GetQuoteFilterClientType;
}
/**
 *
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
  /**
   *
   * @type {Array<ValidationError>}
   * @memberof HTTPValidationError
   */
  detail?: Array<ValidationError>;
}
/**
 *
 * @export
 * @interface IndividualFactorValue
 */
export interface IndividualFactorValue {
  /**
   *
   * @type {SelectedValue}
   * @memberof IndividualFactorValue
   */
  selected_value: SelectedValue;
  /**
   *
   * @type {number}
   * @memberof IndividualFactorValue
   */
  factor_value: number;
}
/**
 *
 * @export
 * @interface Key
 */
export interface Key {}
/**
 * Result for old quotes list
 * @export
 * @interface ListOldQuotesResult
 */
export interface ListOldQuotesResult {
  /**
   *
   * @type {Array<any>}
   * @memberof ListOldQuotesResult
   */
  errors?: Array<any>;
  /**
   *
   * @type {Array<OldQuoteGet>}
   * @memberof ListOldQuotesResult
   */
  quotes?: Array<OldQuoteGet>;
  /**
   *
   * @type {Paging}
   * @memberof ListOldQuotesResult
   */
  paging?: Paging;
}
/**
 *
 * @export
 * @interface ListQuotesV2Result
 */
export interface ListQuotesV2Result {
  /**
   *
   * @type {Array<any>}
   * @memberof ListQuotesV2Result
   */
  errors?: Array<any>;
  /**
   *
   * @type {Array<QuoteV2Get>}
   * @memberof ListQuotesV2Result
   */
  quotes?: Array<QuoteV2Get>;
  /**
   *
   * @type {Paging}
   * @memberof ListQuotesV2Result
   */
  paging?: Paging;
}
/**
 *
 * @export
 * @interface Markups
 */
export interface Markups {
  /**
   *
   * @type {number}
   * @memberof Markups
   */
  video_markup: number;
  /**
   *
   * @type {number}
   * @memberof Markups
   */
  markup_or_discount: number;
}
/**
 * March 2024 factors format
 * @export
 * @interface OldFactors
 */
export interface OldFactors {
  /**
   *
   * @type {number}
   * @memberof OldFactors
   */
  wtp: number;
  /**
   *
   * @type {number}
   * @memberof OldFactors
   */
  labor: number;
}
/**
 * March 2024 price factors format
 * @export
 * @interface OldPriceFactors
 */
export interface OldPriceFactors {
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  universe: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  multi_poll: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  oversample: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  client_type: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  sample_size: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  repeat_client: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  number_of_questions: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  number_of_universes: OldFactors;
  /**
   *
   * @type {OldFactors}
   * @memberof OldPriceFactors
   */
  message_testing_type: OldFactors;
}
/**
 * March 2024 price format
 * @export
 * @interface OldPricingQuotePrice
 */
export interface OldPricingQuotePrice {
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  markup: number;
  /**
   *
   * @type {OldPriceFactors}
   * @memberof OldPricingQuotePrice
   */
  factors: OldPriceFactors;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  wtp_factor: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  asap_markup: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  sample_size: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  labor_factor: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  additional_fees: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  recruitment_cost: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  baseline_labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuotePrice
   */
  number_of_questions: number;
}
/**
 * March 2024 request format
 * @export
 * @interface OldPricingQuoteRequest
 */
export interface OldPricingQuoteRequest {
  /**
   *
   * @type {boolean}
   * @memberof OldPricingQuoteRequest
   */
  asap?: boolean;
  /**
   *
   * @type {string}
   * @memberof OldPricingQuoteRequest
   */
  discount?: string;
  /**
   *
   * @type {Array<DistrictOutput>}
   * @memberof OldPricingQuoteRequest
   */
  districts: Array<DistrictOutput>;
  /**
   *
   * @type {string}
   * @memberof OldPricingQuoteRequest
   */
  client_type: string;
  /**
   *
   * @type {Array<number>}
   * @memberof OldPricingQuoteRequest
   */
  sample_sizes: Array<number>;
  /**
   *
   * @type {string}
   * @memberof OldPricingQuoteRequest
   */
  business_unit: string;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuoteRequest
   */
  manual_markup?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof OldPricingQuoteRequest
   */
  universe_types: Array<string>;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuoteRequest
   */
  additional_fees?: number;
  /**
   *
   * @type {string}
   * @memberof OldPricingQuoteRequest
   */
  message_testing?: string;
  /**
   *
   * @type {string}
   * @memberof OldPricingQuoteRequest
   */
  oversample_type?: string;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuoteRequest
   */
  num_of_universes?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof OldPricingQuoteRequest
   */
  number_of_questions: Array<number>;
  /**
   *
   * @type {number}
   * @memberof OldPricingQuoteRequest
   */
  special_demo_filter_pct?: number;
  /**
   *
   * @type {string}
   * @memberof OldPricingQuoteRequest
   */
  other_universe_type_description?: string;
}
/**
 * March 2024 response format
 * @export
 * @interface OldPricingQuoteResponse
 */
export interface OldPricingQuoteResponse {
  /**
   *
   * @type {OldPricingQuoteRequest}
   * @memberof OldPricingQuoteResponse
   */
  request: OldPricingQuoteRequest;
  /**
   *
   * @type {Array<OldPricingQuotePrice>}
   * @memberof OldPricingQuoteResponse
   */
  prices: Array<OldPricingQuotePrice>;
  /**
   *
   * @type {string}
   * @memberof OldPricingQuoteResponse
   */
  pricing_model_version: string;
}
/**
 * Old quote schema for March 2024 data
 * @export
 * @interface OldQuoteGet
 */
export interface OldQuoteGet {
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  user_email: string;
  /**
   *
   * @type {OldPricingQuoteResponse}
   * @memberof OldQuoteGet
   */
  price_info: OldPricingQuoteResponse;
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  client_name: string;
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  deal_name: string;
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  zendesk_deal_id: string;
  /**
   *
   * @type {FirewallSide}
   * @memberof OldQuoteGet
   */
  firewall_side: FirewallSide;
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  memo?: string | null;
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof OldQuoteGet
   */
  updated_at: string;
  /**
   *
   * @type {Array<DistrictDemoData>}
   * @memberof OldQuoteGet
   */
  district_demo_data?: Array<DistrictDemoData>;
}

/**
 *
 * @export
 * @enum {string}
 */

export const OverSampleType = {
  None: 'none',
  PrimaryVoters: 'primary_voters',
  Other: 'other',
} as const;

export type OverSampleType =
  (typeof OverSampleType)[keyof typeof OverSampleType];

/**
 *
 * @export
 * @interface Paging
 */
export interface Paging {
  /**
   *
   * @type {number}
   * @memberof Paging
   */
  next: number;
  /**
   *
   * @type {number}
   * @memberof Paging
   */
  prev: number;
  /**
   *
   * @type {number}
   * @memberof Paging
   */
  current: number;
  /**
   *
   * @type {number}
   * @memberof Paging
   */
  count: number;
}
/**
 * Represents a single row in the pricing breakdown table
 * @export
 * @interface PricingBreakdownRow
 */
export interface PricingBreakdownRow {
  /**
   *
   * @type {string}
   * @memberof PricingBreakdownRow
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof PricingBreakdownRow
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof PricingBreakdownRow
   */
  calculation: string;
  /**
   *
   * @type {string}
   * @memberof PricingBreakdownRow
   */
  value: string;
  /**
   *
   * @type {boolean}
   * @memberof PricingBreakdownRow
   */
  is_bold?: boolean;
}
/**
 * Contains all pricing breakdown information for display
 * @export
 * @interface PricingBreakdownSectionInput
 */
export interface PricingBreakdownSectionInput {
  /**
   *
   * @type {Array<PricingBreakdownRow>}
   * @memberof PricingBreakdownSectionInput
   */
  breakdown_rows: Array<PricingBreakdownRow>;
  /**
   *
   * @type {FactorBreakdowns}
   * @memberof PricingBreakdownSectionInput
   */
  individual_factor_values: FactorBreakdowns;
}
/**
 * Contains all pricing breakdown information for display
 * @export
 * @interface PricingBreakdownSectionOutput
 */
export interface PricingBreakdownSectionOutput {
  /**
   *
   * @type {Array<PricingBreakdownRow>}
   * @memberof PricingBreakdownSectionOutput
   */
  breakdown_rows: Array<PricingBreakdownRow>;
  /**
   *
   * @type {FactorBreakdowns}
   * @memberof PricingBreakdownSectionOutput
   */
  individual_factor_values: FactorBreakdowns;
}
/**
 *
 * @export
 * @interface PricingQuotePriceInput
 */
export interface PricingQuotePriceInput {
  /**
   *
   * @type {number}
   * @memberof PricingQuotePriceInput
   */
  number_of_questions: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuotePriceInput
   */
  sample_size: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuotePriceInput
   */
  price: number;
  /**
   *
   * @type {SubtotalsInput}
   * @memberof PricingQuotePriceInput
   */
  subtotals: SubtotalsInput;
  /**
   *
   * @type {Markups}
   * @memberof PricingQuotePriceInput
   */
  markups: Markups;
}
/**
 *
 * @export
 * @interface PricingQuotePriceOutput
 */
export interface PricingQuotePriceOutput {
  /**
   *
   * @type {number}
   * @memberof PricingQuotePriceOutput
   */
  number_of_questions: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuotePriceOutput
   */
  sample_size: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuotePriceOutput
   */
  price: number;
  /**
   *
   * @type {SubtotalsOutput}
   * @memberof PricingQuotePriceOutput
   */
  subtotals: SubtotalsOutput;
  /**
   *
   * @type {Markups}
   * @memberof PricingQuotePriceOutput
   */
  markups: Markups;
  /**
   *
   * @type {number}
   * @memberof PricingQuotePriceOutput
   */
  rounded_price: number;
  /**
   * Modeled margin of error (proportion, e.g., 0.03 = 3%)
   * @type {number}
   * @memberof PricingQuotePriceOutput
   */
  modeled_margin_of_error: number;
}
/**
 *
 * @export
 * @interface PricingQuoteRequestInput
 */
export interface PricingQuoteRequestInput {
  /**
   *
   * @type {ClientType}
   * @memberof PricingQuoteRequestInput
   */
  client_type: ClientType;
  /**
   *
   * @type {ClientBudget}
   * @memberof PricingQuoteRequestInput
   */
  client_budget: ClientBudget;
  /**
   *
   * @type {ClientComplexity}
   * @memberof PricingQuoteRequestInput
   */
  client_complexity: ClientComplexity;
  /**
   *
   * @type {ResearchComplexity}
   * @memberof PricingQuoteRequestInput
   */
  research_complexity: ResearchComplexity;
  /**
   *
   * @type {boolean}
   * @memberof PricingQuoteRequestInput
   */
  creative_testing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PricingQuoteRequestInput
   */
  low_bandwidth?: boolean;
  /**
   *
   * @type {Array<DistrictInput>}
   * @memberof PricingQuoteRequestInput
   */
  districts: Array<DistrictInput>;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  num_of_additional_crosstabs: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  num_of_additional_weighting_universes: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  num_of_additional_monitoring_universes: number;
  /**
   *
   * @type {Array<UniverseType>}
   * @memberof PricingQuoteRequestInput
   */
  universe_types: Array<UniverseType>;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  special_demo_filter_pct?: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  markup_or_discount_percentage?: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  absolute_markup_or_discount?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof PricingQuoteRequestInput
   */
  sample_sizes: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof PricingQuoteRequestInput
   */
  number_of_questions: Array<number>;
  /**
   *
   * @type {OverSampleType}
   * @memberof PricingQuoteRequestInput
   */
  oversample_type?: OverSampleType;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  number_of_oversamples: number;
  /**
   *
   * @type {string}
   * @memberof PricingQuoteRequestInput
   */
  other_universe_type_description?: string | null;
  /**
   *
   * @type {string}
   * @memberof PricingQuoteRequestInput
   */
  client_budget_reason?: string | null;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  video_length: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestInput
   */
  max_sample_size?: number | null;
}

/**
 *
 * @export
 * @interface PricingQuoteRequestOutput
 */
export interface PricingQuoteRequestOutput {
  /**
   *
   * @type {ClientType}
   * @memberof PricingQuoteRequestOutput
   */
  client_type: ClientType;
  /**
   *
   * @type {ClientBudget}
   * @memberof PricingQuoteRequestOutput
   */
  client_budget: ClientBudget;
  /**
   *
   * @type {ClientComplexity}
   * @memberof PricingQuoteRequestOutput
   */
  client_complexity: ClientComplexity;
  /**
   *
   * @type {ResearchComplexity}
   * @memberof PricingQuoteRequestOutput
   */
  research_complexity: ResearchComplexity;
  /**
   *
   * @type {boolean}
   * @memberof PricingQuoteRequestOutput
   */
  creative_testing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PricingQuoteRequestOutput
   */
  low_bandwidth?: boolean;
  /**
   *
   * @type {Array<DistrictOutput>}
   * @memberof PricingQuoteRequestOutput
   */
  districts: Array<DistrictOutput>;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  num_of_additional_crosstabs: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  num_of_additional_weighting_universes: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  num_of_additional_monitoring_universes: number;
  /**
   *
   * @type {Array<UniverseType>}
   * @memberof PricingQuoteRequestOutput
   */
  universe_types: Array<UniverseType>;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  special_demo_filter_pct?: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  markup_or_discount_percentage?: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  absolute_markup_or_discount?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof PricingQuoteRequestOutput
   */
  sample_sizes: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof PricingQuoteRequestOutput
   */
  number_of_questions: Array<number>;
  /**
   *
   * @type {OverSampleType}
   * @memberof PricingQuoteRequestOutput
   */
  oversample_type?: OverSampleType;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  number_of_oversamples: number;
  /**
   *
   * @type {string}
   * @memberof PricingQuoteRequestOutput
   */
  other_universe_type_description?: string | null;
  /**
   *
   * @type {string}
   * @memberof PricingQuoteRequestOutput
   */
  client_budget_reason?: string | null;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  video_length: number;
  /**
   *
   * @type {number}
   * @memberof PricingQuoteRequestOutput
   */
  max_sample_size?: number | null;
}

/**
 *
 * @export
 * @interface PricingQuoteResponseInput
 */
export interface PricingQuoteResponseInput {
  /**
   *
   * @type {PricingQuoteRequestInput}
   * @memberof PricingQuoteResponseInput
   */
  request: PricingQuoteRequestInput;
  /**
   *
   * @type {Array<PricingQuotePriceInput>}
   * @memberof PricingQuoteResponseInput
   */
  prices: Array<PricingQuotePriceInput>;
  /**
   *
   * @type {string}
   * @memberof PricingQuoteResponseInput
   */
  pricing_model_version: string;
}
/**
 *
 * @export
 * @interface PricingQuoteResponseOutput
 */
export interface PricingQuoteResponseOutput {
  /**
   *
   * @type {PricingQuoteRequestOutput}
   * @memberof PricingQuoteResponseOutput
   */
  request: PricingQuoteRequestOutput;
  /**
   *
   * @type {Array<PricingQuotePriceOutput>}
   * @memberof PricingQuoteResponseOutput
   */
  prices: Array<PricingQuotePriceOutput>;
  /**
   *
   * @type {string}
   * @memberof PricingQuoteResponseOutput
   */
  pricing_model_version: string;
}
/**
 *
 * @export
 * @interface QuoteCreate
 */
export interface QuoteCreate {
  /**
   *
   * @type {PricingQuoteResponseInput}
   * @memberof QuoteCreate
   */
  price_info: PricingQuoteResponseInput;
  /**
   *
   * @type {string}
   * @memberof QuoteCreate
   */
  client_name: string;
  /**
   *
   * @type {string}
   * @memberof QuoteCreate
   */
  deal_name: string;
  /**
   *
   * @type {FirewallSide}
   * @memberof QuoteCreate
   */
  firewall_side: FirewallSide;
  /**
   *
   * @type {string}
   * @memberof QuoteCreate
   */
  zendesk_deal_id: string;
  /**
   *
   * @type {string}
   * @memberof QuoteCreate
   */
  user_email: string;
  /**
   *
   * @type {string}
   * @memberof QuoteCreate
   */
  memo?: string | null;
}

/**
 *
 * @export
 * @interface QuoteGet
 */
export interface QuoteGet {
  /**
   *
   * @type {PricingQuoteResponseOutput}
   * @memberof QuoteGet
   */
  price_info: PricingQuoteResponseOutput;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  client_name: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  deal_name: string;
  /**
   *
   * @type {FirewallSide}
   * @memberof QuoteGet
   */
  firewall_side: FirewallSide;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  zendesk_deal_id: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  user_email: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  memo?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGet
   */
  updated_at: string;
  /**
   *
   * @type {Array<DistrictDemoData>}
   * @memberof QuoteGet
   */
  district_demo_data: Array<DistrictDemoData>;
}

/**
 *
 * @export
 * @interface QuoteUpdate
 */
export interface QuoteUpdate {
  /**
   *
   * @type {PricingQuoteResponseInput}
   * @memberof QuoteUpdate
   */
  price_info: PricingQuoteResponseInput | null;
  /**
   *
   * @type {string}
   * @memberof QuoteUpdate
   */
  client_name: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteUpdate
   */
  deal_name: string | null;
  /**
   *
   * @type {FirewallSide}
   * @memberof QuoteUpdate
   */
  firewall_side: FirewallSide | null;
  /**
   *
   * @type {string}
   * @memberof QuoteUpdate
   */
  zendesk_deal_id: string | null;
}

/**
 *
 * @export
 * @interface QuoteV2Create
 */
export interface QuoteV2Create {
  /**
   *
   * @type {PricingQuoteResponseInput}
   * @memberof QuoteV2Create
   */
  price_info: PricingQuoteResponseInput;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Create
   */
  client_name: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Create
   */
  deal_name: string;
  /**
   *
   * @type {FirewallSide}
   * @memberof QuoteV2Create
   */
  firewall_side: FirewallSide;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Create
   */
  zendesk_deal_id: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Create
   */
  memo?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Create
   */
  user_email: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Create
   */
  version?: string;
}

/**
 *
 * @export
 * @interface QuoteV2Get
 */
export interface QuoteV2Get {
  /**
   *
   * @type {PricingQuoteResponseOutput}
   * @memberof QuoteV2Get
   */
  price_info: PricingQuoteResponseOutput;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  client_name: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  deal_name: string;
  /**
   *
   * @type {FirewallSide}
   * @memberof QuoteV2Get
   */
  firewall_side: FirewallSide;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  zendesk_deal_id: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  memo?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  user_email: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  version?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Get
   */
  updated_at: string;
  /**
   *
   * @type {Array<DistrictDemoData>}
   * @memberof QuoteV2Get
   */
  district_demo_data: Array<DistrictDemoData>;
}

/**
 *
 * @export
 * @interface QuoteV2Update
 */
export interface QuoteV2Update {
  /**
   *
   * @type {PricingQuoteResponseInput}
   * @memberof QuoteV2Update
   */
  price_info: PricingQuoteResponseInput | null;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Update
   */
  client_name: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Update
   */
  deal_name: string | null;
  /**
   *
   * @type {FirewallSide}
   * @memberof QuoteV2Update
   */
  firewall_side: FirewallSide | null;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Update
   */
  zendesk_deal_id: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteV2Update
   */
  memo?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ResearchComplexity = {
  Standard: 'standard',
  High: 'high',
  Ultra: 'ultra',
} as const;

export type ResearchComplexity =
  (typeof ResearchComplexity)[keyof typeof ResearchComplexity];

/**
 *
 * @export
 * @interface SelectedValue
 */
export interface SelectedValue {}
/**
 *
 * @export
 * @enum {string}
 */

export const State = {
  Alabama: 'Alabama',
  Alaska: 'Alaska',
  Arizona: 'Arizona',
  Arkansas: 'Arkansas',
  California: 'California',
  Colorado: 'Colorado',
  Connecticut: 'Connecticut',
  Delaware: 'Delaware',
  DistrictOfColumbia: 'District Of Columbia',
  Florida: 'Florida',
  Georgia: 'Georgia',
  Hawaii: 'Hawaii',
  Idaho: 'Idaho',
  Illinois: 'Illinois',
  Indiana: 'Indiana',
  Iowa: 'Iowa',
  Kansas: 'Kansas',
  Kentucky: 'Kentucky',
  Louisiana: 'Louisiana',
  Maine: 'Maine',
  Maryland: 'Maryland',
  Massachusetts: 'Massachusetts',
  Michigan: 'Michigan',
  Minnesota: 'Minnesota',
  Mississippi: 'Mississippi',
  Missouri: 'Missouri',
  Montana: 'Montana',
  Nebraska: 'Nebraska',
  Nevada: 'Nevada',
  NewHampshire: 'New Hampshire',
  NewJersey: 'New Jersey',
  NewMexico: 'New Mexico',
  NewYork: 'New York',
  NorthCarolina: 'North Carolina',
  NorthDakota: 'North Dakota',
  Ohio: 'Ohio',
  Oklahoma: 'Oklahoma',
  Oregon: 'Oregon',
  Pennsylvania: 'Pennsylvania',
  RhodeIsland: 'Rhode Island',
  SouthCarolina: 'South Carolina',
  SouthDakota: 'South Dakota',
  Tennessee: 'Tennessee',
  Texas: 'Texas',
  Utah: 'Utah',
  Vermont: 'Vermont',
  Virginia: 'Virginia',
  Washington: 'Washington',
  WestVirginia: 'West Virginia',
  Wisconsin: 'Wisconsin',
  Wyoming: 'Wyoming',
  Usa: 'USA',
} as const;

export type State = (typeof State)[keyof typeof State];

/**
 *
 * @export
 * @interface SubtotalsInput
 */
export interface SubtotalsInput {
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  recruitment_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  baseline_labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  budget_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  additional_labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  labor_plus_recruitment: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  price_before_adjustment: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  total_adjustment: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  labor_factor: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  budget_factor: number;
  /**
   *
   * @type {AdditionalLaborFees}
   * @memberof SubtotalsInput
   */
  additional_labor_fees: AdditionalLaborFees;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  total_universe_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsInput
   */
  baseline_universe_cost: number;
  /**
   *
   * @type {FactorBreakdowns}
   * @memberof SubtotalsInput
   */
  factor_breakdowns: FactorBreakdowns;
  /**
   *
   * @type {PricingBreakdownSectionInput}
   * @memberof SubtotalsInput
   */
  pricing_breakdown: PricingBreakdownSectionInput;
}
/**
 *
 * @export
 * @interface SubtotalsOutput
 */
export interface SubtotalsOutput {
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  recruitment_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  baseline_labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  budget_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  additional_labor_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  labor_plus_recruitment: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  price_before_adjustment: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  total_adjustment: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  labor_factor: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  budget_factor: number;
  /**
   *
   * @type {AdditionalLaborFees}
   * @memberof SubtotalsOutput
   */
  additional_labor_fees: AdditionalLaborFees;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  total_universe_cost: number;
  /**
   *
   * @type {number}
   * @memberof SubtotalsOutput
   */
  baseline_universe_cost: number;
  /**
   *
   * @type {FactorBreakdowns}
   * @memberof SubtotalsOutput
   */
  factor_breakdowns: FactorBreakdowns;
  /**
   *
   * @type {PricingBreakdownSectionOutput}
   * @memberof SubtotalsOutput
   */
  pricing_breakdown: PricingBreakdownSectionOutput;
}
/**
 *
 * @export
 * @enum {string}
 */

export const UniverseType = {
  RegisteredVoters: 'registered_voters',
  EvenYearGeneral: 'even_year_general',
  OddYearGeneral: 'odd_year_general',
  PrimaryLocalSpecialElection: 'primary_local_special_election',
  DemPrimary: 'dem_primary',
  LocalSpecialElection: 'local_special_election',
  OtherNonStandard: 'other_non_standard',
  AllAdults: 'all_adults',
} as const;

export type UniverseType = (typeof UniverseType)[keyof typeof UniverseType];

/**
 *
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
  /**
   *
   * @type {Array<ValidationErrorLocInner>}
   * @memberof ValidationError
   */
  loc: Array<ValidationErrorLocInner>;
  /**
   *
   * @type {string}
   * @memberof ValidationError
   */
  msg: string;
  /**
   *
   * @type {string}
   * @memberof ValidationError
   */
  type: string;
}
/**
 *
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {}
/**
 *
 * @export
 * @interface Weight
 */
export interface Weight {
  /**
   *
   * @type {Key}
   * @memberof Weight
   */
  key: Key;
  /**
   *
   * @type {number}
   * @memberof Weight
   */
  labor: number | null;
  /**
   *
   * @type {number}
   * @memberof Weight
   */
  budget: number | null;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthHealthGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/health`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBasic required
      // http basic authentication required
      setBasicAuthToObject(localVarRequestOptions, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Private Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    privateTestPrivateGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/private`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healthHealthGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.healthHealthGet(
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DefaultApi.healthHealthGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Private Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async privateTestPrivateGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.privateTestPrivateGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DefaultApi.privateTestPrivateGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     *
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .healthHealthGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Private Test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    privateTestPrivateGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .privateTestPrivateGet(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary Health
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public healthHealthGet(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .healthHealthGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Private Test
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public privateTestPrivateGet(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .privateTestPrivateGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * GeoservicesApi - axios parameter creator
 * @export
 */
export const GeoservicesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get the demo data for multiple geographic entities
     * @summary List Demo Data
     * @param {Array<DistrictQuery>} districtQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDemoDataGeoDemoPost: async (
      districtQuery: Array<DistrictQuery>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'districtQuery' is not null or undefined
      assertParamExists(
        'listDemoDataGeoDemoPost',
        'districtQuery',
        districtQuery,
      );
      const localVarPath = `/geo/demo`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        districtQuery,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List Districts
     * @param {State} state
     * @param {DistrictType | null} [districtType]
     * @param {string | null} [districtName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDistrictsGeoDistrictsStateGet: async (
      state: State,
      districtType?: DistrictType | null,
      districtName?: string | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'state' is not null or undefined
      assertParamExists('listDistrictsGeoDistrictsStateGet', 'state', state);
      const localVarPath = `/geo/districts/{state}`.replace(
        `{${'state'}}`,
        encodeURIComponent(String(state)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (districtType !== undefined) {
        localVarQueryParameter['district_type'] = districtType;
      }

      if (districtName !== undefined) {
        localVarQueryParameter['district_name'] = districtName;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * List demo data for a single state (and optionally district type and district name)
     * @summary List Single State Demo Data
     * @param {State} state
     * @param {DistrictType | null} [districtType]
     * @param {string | null} [districtName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSingleStateDemoDataGeoDemoStateGet: async (
      state: State,
      districtType?: DistrictType | null,
      districtName?: string | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'state' is not null or undefined
      assertParamExists(
        'listSingleStateDemoDataGeoDemoStateGet',
        'state',
        state,
      );
      const localVarPath = `/geo/demo/{state}`.replace(
        `{${'state'}}`,
        encodeURIComponent(String(state)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (districtType !== undefined) {
        localVarQueryParameter['district_type'] = districtType;
      }

      if (districtName !== undefined) {
        localVarQueryParameter['district_name'] = districtName;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GeoservicesApi - functional programming interface
 * @export
 */
export const GeoservicesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    GeoservicesApiAxiosParamCreator(configuration);
  return {
    /**
     * Get the demo data for multiple geographic entities
     * @summary List Demo Data
     * @param {Array<DistrictQuery>} districtQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listDemoDataGeoDemoPost(
      districtQuery: Array<DistrictQuery>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DistrictDemoData>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listDemoDataGeoDemoPost(
          districtQuery,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GeoservicesApi.listDemoDataGeoDemoPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List Districts
     * @param {State} state
     * @param {DistrictType | null} [districtType]
     * @param {string | null} [districtName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listDistrictsGeoDistrictsStateGet(
      state: State,
      districtType?: DistrictType | null,
      districtName?: string | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DistrictOutput>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listDistrictsGeoDistrictsStateGet(
          state,
          districtType,
          districtName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'GeoservicesApi.listDistrictsGeoDistrictsStateGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * List demo data for a single state (and optionally district type and district name)
     * @summary List Single State Demo Data
     * @param {State} state
     * @param {DistrictType | null} [districtType]
     * @param {string | null} [districtName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listSingleStateDemoDataGeoDemoStateGet(
      state: State,
      districtType?: DistrictType | null,
      districtName?: string | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DistrictDemoData>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listSingleStateDemoDataGeoDemoStateGet(
          state,
          districtType,
          districtName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'GeoservicesApi.listSingleStateDemoDataGeoDemoStateGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * GeoservicesApi - factory interface
 * @export
 */
export const GeoservicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = GeoservicesApiFp(configuration);
  return {
    /**
     * Get the demo data for multiple geographic entities
     * @summary List Demo Data
     * @param {Array<DistrictQuery>} districtQuery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDemoDataGeoDemoPost(
      districtQuery: Array<DistrictQuery>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<DistrictDemoData>> {
      return localVarFp
        .listDemoDataGeoDemoPost(districtQuery, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List Districts
     * @param {State} state
     * @param {DistrictType | null} [districtType]
     * @param {string | null} [districtName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDistrictsGeoDistrictsStateGet(
      state: State,
      districtType?: DistrictType | null,
      districtName?: string | null,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<DistrictOutput>> {
      return localVarFp
        .listDistrictsGeoDistrictsStateGet(
          state,
          districtType,
          districtName,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * List demo data for a single state (and optionally district type and district name)
     * @summary List Single State Demo Data
     * @param {State} state
     * @param {DistrictType | null} [districtType]
     * @param {string | null} [districtName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listSingleStateDemoDataGeoDemoStateGet(
      state: State,
      districtType?: DistrictType | null,
      districtName?: string | null,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<DistrictDemoData>> {
      return localVarFp
        .listSingleStateDemoDataGeoDemoStateGet(
          state,
          districtType,
          districtName,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * GeoservicesApi - object-oriented interface
 * @export
 * @class GeoservicesApi
 * @extends {BaseAPI}
 */
export class GeoservicesApi extends BaseAPI {
  /**
   * Get the demo data for multiple geographic entities
   * @summary List Demo Data
   * @param {Array<DistrictQuery>} districtQuery
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GeoservicesApi
   */
  public listDemoDataGeoDemoPost(
    districtQuery: Array<DistrictQuery>,
    options?: RawAxiosRequestConfig,
  ) {
    return GeoservicesApiFp(this.configuration)
      .listDemoDataGeoDemoPost(districtQuery, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List Districts
   * @param {State} state
   * @param {DistrictType | null} [districtType]
   * @param {string | null} [districtName]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GeoservicesApi
   */
  public listDistrictsGeoDistrictsStateGet(
    state: State,
    districtType?: DistrictType | null,
    districtName?: string | null,
    options?: RawAxiosRequestConfig,
  ) {
    return GeoservicesApiFp(this.configuration)
      .listDistrictsGeoDistrictsStateGet(
        state,
        districtType,
        districtName,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * List demo data for a single state (and optionally district type and district name)
   * @summary List Single State Demo Data
   * @param {State} state
   * @param {DistrictType | null} [districtType]
   * @param {string | null} [districtName]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GeoservicesApi
   */
  public listSingleStateDemoDataGeoDemoStateGet(
    state: State,
    districtType?: DistrictType | null,
    districtName?: string | null,
    options?: RawAxiosRequestConfig,
  ) {
    return GeoservicesApiFp(this.configuration)
      .listSingleStateDemoDataGeoDemoStateGet(
        state,
        districtType,
        districtName,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PricingApi - axios parameter creator
 * @export
 */
export const PricingApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Current Factors
     * @param {boolean} [all] Include all the factors including the large continuous factors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentFactorsPricingFactorsGet: async (
      all?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/pricing/factors`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (all !== undefined) {
        localVarQueryParameter['all'] = all;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Price Quote
     * @param {PricingQuoteRequestInput} pricingQuoteRequestInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceQuotePricingPost: async (
      pricingQuoteRequestInput: PricingQuoteRequestInput,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pricingQuoteRequestInput' is not null or undefined
      assertParamExists(
        'priceQuotePricingPost',
        'pricingQuoteRequestInput',
        pricingQuoteRequestInput,
      );
      const localVarPath = `/pricing/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pricingQuoteRequestInput,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PricingApi - functional programming interface
 * @export
 */
export const PricingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PricingApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Current Factors
     * @param {boolean} [all] Include all the factors including the large continuous factors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currentFactorsPricingFactorsGet(
      all?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Factor>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.currentFactorsPricingFactorsGet(
          all,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PricingApi.currentFactorsPricingFactorsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Price Quote
     * @param {PricingQuoteRequestInput} pricingQuoteRequestInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceQuotePricingPost(
      pricingQuoteRequestInput: PricingQuoteRequestInput,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PricingQuoteResponseOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.priceQuotePricingPost(
          pricingQuoteRequestInput,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PricingApi.priceQuotePricingPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PricingApi - factory interface
 * @export
 */
export const PricingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PricingApiFp(configuration);
  return {
    /**
     *
     * @summary Current Factors
     * @param {boolean} [all] Include all the factors including the large continuous factors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentFactorsPricingFactorsGet(
      all?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Factor>> {
      return localVarFp
        .currentFactorsPricingFactorsGet(all, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Price Quote
     * @param {PricingQuoteRequestInput} pricingQuoteRequestInput
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceQuotePricingPost(
      pricingQuoteRequestInput: PricingQuoteRequestInput,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PricingQuoteResponseOutput> {
      return localVarFp
        .priceQuotePricingPost(pricingQuoteRequestInput, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PricingApi - object-oriented interface
 * @export
 * @class PricingApi
 * @extends {BaseAPI}
 */
export class PricingApi extends BaseAPI {
  /**
   *
   * @summary Current Factors
   * @param {boolean} [all] Include all the factors including the large continuous factors
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricingApi
   */
  public currentFactorsPricingFactorsGet(
    all?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return PricingApiFp(this.configuration)
      .currentFactorsPricingFactorsGet(all, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Price Quote
   * @param {PricingQuoteRequestInput} pricingQuoteRequestInput
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PricingApi
   */
  public priceQuotePricingPost(
    pricingQuoteRequestInput: PricingQuoteRequestInput,
    options?: RawAxiosRequestConfig,
  ) {
    return PricingApiFp(this.configuration)
      .priceQuotePricingPost(pricingQuoteRequestInput, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QuotesApi - axios parameter creator
 * @export
 */
export const QuotesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Create Quote
     * @param {QuoteCreate} quoteCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createQuoteQuotesPost: async (
      quoteCreate: QuoteCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quoteCreate' is not null or undefined
      assertParamExists('createQuoteQuotesPost', 'quoteCreate', quoteCreate);
      const localVarPath = `/quotes/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quoteCreate,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * This is just to get the example filter into the OpenAPI docs, not actually used
     * @summary Example Filter
     * @param {GetQuoteFilter} getQuoteFilter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    exampleFilterQuotesExampleFilterPost: async (
      getQuoteFilter: GetQuoteFilter,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'getQuoteFilter' is not null or undefined
      assertParamExists(
        'exampleFilterQuotesExampleFilterPost',
        'getQuoteFilter',
        getQuoteFilter,
      );
      const localVarPath = `/quotes/exampleFilter/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getQuoteFilter,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get Quote
     * @param {string} quoteId
     * @param {boolean} [includeDemoData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuoteQuotesQuoteIdGet: async (
      quoteId: string,
      includeDemoData?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quoteId' is not null or undefined
      assertParamExists('getQuoteQuotesQuoteIdGet', 'quoteId', quoteId);
      const localVarPath = `/quotes/{quote_id}`.replace(
        `{${'quote_id'}}`,
        encodeURIComponent(String(quoteId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (includeDemoData !== undefined) {
        localVarQueryParameter['include_demo_data'] = includeDemoData;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List Quotes
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listQuotesQuotesGet: async (
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/quotes/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageSize !== undefined) {
        localVarQueryParameter['page_size'] = pageSize;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (filter !== undefined) {
        localVarQueryParameter['filter'] = filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search Client Name
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchClientNameQuotesSearchClientGet: async (
      query: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists(
        'searchClientNameQuotesSearchClientGet',
        'query',
        query,
      );
      const localVarPath = `/quotes/search/client/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search Deal Name
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDealNameQuotesSearchDealGet: async (
      query: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists('searchDealNameQuotesSearchDealGet', 'query', query);
      const localVarPath = `/quotes/search/deal/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update Quote
     * @param {string} quoteId
     * @param {QuoteUpdate} quoteUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuoteQuotesQuoteIdPut: async (
      quoteId: string,
      quoteUpdate: QuoteUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quoteId' is not null or undefined
      assertParamExists('updateQuoteQuotesQuoteIdPut', 'quoteId', quoteId);
      // verify required parameter 'quoteUpdate' is not null or undefined
      assertParamExists(
        'updateQuoteQuotesQuoteIdPut',
        'quoteUpdate',
        quoteUpdate,
      );
      const localVarPath = `/quotes/{quote_id}`.replace(
        `{${'quote_id'}}`,
        encodeURIComponent(String(quoteId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quoteUpdate,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QuotesApi - functional programming interface
 * @export
 */
export const QuotesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = QuotesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create Quote
     * @param {QuoteCreate} quoteCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createQuoteQuotesPost(
      quoteCreate: QuoteCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteGet>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createQuoteQuotesPost(
          quoteCreate,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesApi.createQuoteQuotesPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This is just to get the example filter into the OpenAPI docs, not actually used
     * @summary Example Filter
     * @param {GetQuoteFilter} getQuoteFilter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async exampleFilterQuotesExampleFilterPost(
      getQuoteFilter: GetQuoteFilter,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuoteFilter>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.exampleFilterQuotesExampleFilterPost(
          getQuoteFilter,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesApi.exampleFilterQuotesExampleFilterPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Quote
     * @param {string} quoteId
     * @param {boolean} [includeDemoData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getQuoteQuotesQuoteIdGet(
      quoteId: string,
      includeDemoData?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OldQuoteGet>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getQuoteQuotesQuoteIdGet(
          quoteId,
          includeDemoData,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesApi.getQuoteQuotesQuoteIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List Quotes
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listQuotesQuotesGet(
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ListOldQuotesResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listQuotesQuotesGet(
          pageSize,
          offset,
          filter,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesApi.listQuotesQuotesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Search Client Name
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchClientNameQuotesSearchClientGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<string | null>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.searchClientNameQuotesSearchClientGet(
          query,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesApi.searchClientNameQuotesSearchClientGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Search Deal Name
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchDealNameQuotesSearchDealGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<string | null>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.searchDealNameQuotesSearchDealGet(
          query,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesApi.searchDealNameQuotesSearchDealGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Quote
     * @param {string} quoteId
     * @param {QuoteUpdate} quoteUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateQuoteQuotesQuoteIdPut(
      quoteId: string,
      quoteUpdate: QuoteUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteGet>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateQuoteQuotesQuoteIdPut(
          quoteId,
          quoteUpdate,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesApi.updateQuoteQuotesQuoteIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QuotesApi - factory interface
 * @export
 */
export const QuotesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QuotesApiFp(configuration);
  return {
    /**
     *
     * @summary Create Quote
     * @param {QuoteCreate} quoteCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createQuoteQuotesPost(
      quoteCreate: QuoteCreate,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QuoteGet> {
      return localVarFp
        .createQuoteQuotesPost(quoteCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This is just to get the example filter into the OpenAPI docs, not actually used
     * @summary Example Filter
     * @param {GetQuoteFilter} getQuoteFilter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    exampleFilterQuotesExampleFilterPost(
      getQuoteFilter: GetQuoteFilter,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetQuoteFilter> {
      return localVarFp
        .exampleFilterQuotesExampleFilterPost(getQuoteFilter, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Quote
     * @param {string} quoteId
     * @param {boolean} [includeDemoData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuoteQuotesQuoteIdGet(
      quoteId: string,
      includeDemoData?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OldQuoteGet> {
      return localVarFp
        .getQuoteQuotesQuoteIdGet(quoteId, includeDemoData, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List Quotes
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listQuotesQuotesGet(
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ListOldQuotesResult> {
      return localVarFp
        .listQuotesQuotesGet(pageSize, offset, filter, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search Client Name
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchClientNameQuotesSearchClientGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<string | null>> {
      return localVarFp
        .searchClientNameQuotesSearchClientGet(query, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search Deal Name
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDealNameQuotesSearchDealGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<string | null>> {
      return localVarFp
        .searchDealNameQuotesSearchDealGet(query, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Quote
     * @param {string} quoteId
     * @param {QuoteUpdate} quoteUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuoteQuotesQuoteIdPut(
      quoteId: string,
      quoteUpdate: QuoteUpdate,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QuoteGet> {
      return localVarFp
        .updateQuoteQuotesQuoteIdPut(quoteId, quoteUpdate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QuotesApi - object-oriented interface
 * @export
 * @class QuotesApi
 * @extends {BaseAPI}
 */
export class QuotesApi extends BaseAPI {
  /**
   *
   * @summary Create Quote
   * @param {QuoteCreate} quoteCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesApi
   */
  public createQuoteQuotesPost(
    quoteCreate: QuoteCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesApiFp(this.configuration)
      .createQuoteQuotesPost(quoteCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This is just to get the example filter into the OpenAPI docs, not actually used
   * @summary Example Filter
   * @param {GetQuoteFilter} getQuoteFilter
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof QuotesApi
   */
  public exampleFilterQuotesExampleFilterPost(
    getQuoteFilter: GetQuoteFilter,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesApiFp(this.configuration)
      .exampleFilterQuotesExampleFilterPost(getQuoteFilter, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Quote
   * @param {string} quoteId
   * @param {boolean} [includeDemoData]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesApi
   */
  public getQuoteQuotesQuoteIdGet(
    quoteId: string,
    includeDemoData?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesApiFp(this.configuration)
      .getQuoteQuotesQuoteIdGet(quoteId, includeDemoData, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List Quotes
   * @param {number} [pageSize]
   * @param {number} [offset]
   * @param {string | null} [filter] Query filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesApi
   */
  public listQuotesQuotesGet(
    pageSize?: number,
    offset?: number,
    filter?: string | null,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesApiFp(this.configuration)
      .listQuotesQuotesGet(pageSize, offset, filter, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search Client Name
   * @param {string} query
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesApi
   */
  public searchClientNameQuotesSearchClientGet(
    query: string,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesApiFp(this.configuration)
      .searchClientNameQuotesSearchClientGet(query, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search Deal Name
   * @param {string} query
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesApi
   */
  public searchDealNameQuotesSearchDealGet(
    query: string,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesApiFp(this.configuration)
      .searchDealNameQuotesSearchDealGet(query, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Quote
   * @param {string} quoteId
   * @param {QuoteUpdate} quoteUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesApi
   */
  public updateQuoteQuotesQuoteIdPut(
    quoteId: string,
    quoteUpdate: QuoteUpdate,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesApiFp(this.configuration)
      .updateQuoteQuotesQuoteIdPut(quoteId, quoteUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * QuotesV2Api - axios parameter creator
 * @export
 */
export const QuotesV2ApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Create Quote V2
     * @param {QuoteV2Create} quoteV2Create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createQuoteV2QuotesV2Post: async (
      quoteV2Create: QuoteV2Create,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quoteV2Create' is not null or undefined
      assertParamExists(
        'createQuoteV2QuotesV2Post',
        'quoteV2Create',
        quoteV2Create,
      );
      const localVarPath = `/quotes/v2/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quoteV2Create,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create Quote V2
     * @param {QuoteV2Create} quoteV2Create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createQuoteV2QuotesV2Post_1: async (
      quoteV2Create: QuoteV2Create,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quoteV2Create' is not null or undefined
      assertParamExists(
        'createQuoteV2QuotesV2Post_1',
        'quoteV2Create',
        quoteV2Create,
      );
      const localVarPath = `/quotes/v2`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quoteV2Create,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * This is just to get the example filter into the OpenAPI docs, not actually used
     * @summary Example Filter V2
     * @param {GetQuoteV2Filter} getQuoteV2Filter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    exampleFilterV2QuotesV2ExampleFilterPost: async (
      getQuoteV2Filter: GetQuoteV2Filter,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'getQuoteV2Filter' is not null or undefined
      assertParamExists(
        'exampleFilterV2QuotesV2ExampleFilterPost',
        'getQuoteV2Filter',
        getQuoteV2Filter,
      );
      const localVarPath = `/quotes/v2/exampleFilter/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getQuoteV2Filter,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get Quote V2
     * @param {string} quoteId
     * @param {boolean} [includeDemoData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuoteV2QuotesV2QuoteIdGet: async (
      quoteId: string,
      includeDemoData?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quoteId' is not null or undefined
      assertParamExists('getQuoteV2QuotesV2QuoteIdGet', 'quoteId', quoteId);
      const localVarPath = `/quotes/v2/{quote_id}`.replace(
        `{${'quote_id'}}`,
        encodeURIComponent(String(quoteId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (includeDemoData !== undefined) {
        localVarQueryParameter['include_demo_data'] = includeDemoData;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List Quotes V2
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listQuotesV2QuotesV2Get: async (
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/quotes/v2/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageSize !== undefined) {
        localVarQueryParameter['page_size'] = pageSize;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (filter !== undefined) {
        localVarQueryParameter['filter'] = filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List Quotes V2
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listQuotesV2QuotesV2Get_2: async (
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/quotes/v2`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageSize !== undefined) {
        localVarQueryParameter['page_size'] = pageSize;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (filter !== undefined) {
        localVarQueryParameter['filter'] = filter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search Client Name V2
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchClientNameV2QuotesV2SearchClientGet: async (
      query: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists(
        'searchClientNameV2QuotesV2SearchClientGet',
        'query',
        query,
      );
      const localVarPath = `/quotes/v2/search/client/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search Deal Name V2
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDealNameV2QuotesV2SearchDealGet: async (
      query: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'query' is not null or undefined
      assertParamExists(
        'searchDealNameV2QuotesV2SearchDealGet',
        'query',
        query,
      );
      const localVarPath = `/quotes/v2/search/deal/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update Quote V2
     * @param {string} quoteId
     * @param {QuoteV2Update} quoteV2Update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuoteV2QuotesV2QuoteIdPut: async (
      quoteId: string,
      quoteV2Update: QuoteV2Update,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'quoteId' is not null or undefined
      assertParamExists('updateQuoteV2QuotesV2QuoteIdPut', 'quoteId', quoteId);
      // verify required parameter 'quoteV2Update' is not null or undefined
      assertParamExists(
        'updateQuoteV2QuotesV2QuoteIdPut',
        'quoteV2Update',
        quoteV2Update,
      );
      const localVarPath = `/quotes/v2/{quote_id}`.replace(
        `{${'quote_id'}}`,
        encodeURIComponent(String(quoteId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quoteV2Update,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QuotesV2Api - functional programming interface
 * @export
 */
export const QuotesV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = QuotesV2ApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create Quote V2
     * @param {QuoteV2Create} quoteV2Create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createQuoteV2QuotesV2Post(
      quoteV2Create: QuoteV2Create,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteV2Get>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createQuoteV2QuotesV2Post(
          quoteV2Create,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesV2Api.createQuoteV2QuotesV2Post']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Quote V2
     * @param {QuoteV2Create} quoteV2Create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createQuoteV2QuotesV2Post_1(
      quoteV2Create: QuoteV2Create,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteV2Get>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createQuoteV2QuotesV2Post_1(
          quoteV2Create,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesV2Api.createQuoteV2QuotesV2Post_1']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This is just to get the example filter into the OpenAPI docs, not actually used
     * @summary Example Filter V2
     * @param {GetQuoteV2Filter} getQuoteV2Filter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async exampleFilterV2QuotesV2ExampleFilterPost(
      getQuoteV2Filter: GetQuoteV2Filter,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetQuoteV2Filter>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.exampleFilterV2QuotesV2ExampleFilterPost(
          getQuoteV2Filter,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'QuotesV2Api.exampleFilterV2QuotesV2ExampleFilterPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Quote V2
     * @param {string} quoteId
     * @param {boolean} [includeDemoData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getQuoteV2QuotesV2QuoteIdGet(
      quoteId: string,
      includeDemoData?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteV2Get>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getQuoteV2QuotesV2QuoteIdGet(
          quoteId,
          includeDemoData,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesV2Api.getQuoteV2QuotesV2QuoteIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List Quotes V2
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listQuotesV2QuotesV2Get(
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ListQuotesV2Result>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listQuotesV2QuotesV2Get(
          pageSize,
          offset,
          filter,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesV2Api.listQuotesV2QuotesV2Get']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List Quotes V2
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listQuotesV2QuotesV2Get_2(
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ListQuotesV2Result>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.listQuotesV2QuotesV2Get_2(
          pageSize,
          offset,
          filter,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesV2Api.listQuotesV2QuotesV2Get_2']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Search Client Name V2
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchClientNameV2QuotesV2SearchClientGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<string | null>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.searchClientNameV2QuotesV2SearchClientGet(
          query,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'QuotesV2Api.searchClientNameV2QuotesV2SearchClientGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Search Deal Name V2
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchDealNameV2QuotesV2SearchDealGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<string | null>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.searchDealNameV2QuotesV2SearchDealGet(
          query,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'QuotesV2Api.searchDealNameV2QuotesV2SearchDealGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Quote V2
     * @param {string} quoteId
     * @param {QuoteV2Update} quoteV2Update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateQuoteV2QuotesV2QuoteIdPut(
      quoteId: string,
      quoteV2Update: QuoteV2Update,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteV2Get>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateQuoteV2QuotesV2QuoteIdPut(
          quoteId,
          quoteV2Update,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QuotesV2Api.updateQuoteV2QuotesV2QuoteIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QuotesV2Api - factory interface
 * @export
 */
export const QuotesV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QuotesV2ApiFp(configuration);
  return {
    /**
     *
     * @summary Create Quote V2
     * @param {QuoteV2Create} quoteV2Create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createQuoteV2QuotesV2Post(
      quoteV2Create: QuoteV2Create,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QuoteV2Get> {
      return localVarFp
        .createQuoteV2QuotesV2Post(quoteV2Create, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Quote V2
     * @param {QuoteV2Create} quoteV2Create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createQuoteV2QuotesV2Post_1(
      quoteV2Create: QuoteV2Create,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QuoteV2Get> {
      return localVarFp
        .createQuoteV2QuotesV2Post_1(quoteV2Create, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This is just to get the example filter into the OpenAPI docs, not actually used
     * @summary Example Filter V2
     * @param {GetQuoteV2Filter} getQuoteV2Filter
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    exampleFilterV2QuotesV2ExampleFilterPost(
      getQuoteV2Filter: GetQuoteV2Filter,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetQuoteV2Filter> {
      return localVarFp
        .exampleFilterV2QuotesV2ExampleFilterPost(getQuoteV2Filter, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Quote V2
     * @param {string} quoteId
     * @param {boolean} [includeDemoData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuoteV2QuotesV2QuoteIdGet(
      quoteId: string,
      includeDemoData?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QuoteV2Get> {
      return localVarFp
        .getQuoteV2QuotesV2QuoteIdGet(quoteId, includeDemoData, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List Quotes V2
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listQuotesV2QuotesV2Get(
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ListQuotesV2Result> {
      return localVarFp
        .listQuotesV2QuotesV2Get(pageSize, offset, filter, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List Quotes V2
     * @param {number} [pageSize]
     * @param {number} [offset]
     * @param {string | null} [filter] Query filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listQuotesV2QuotesV2Get_2(
      pageSize?: number,
      offset?: number,
      filter?: string | null,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ListQuotesV2Result> {
      return localVarFp
        .listQuotesV2QuotesV2Get_2(pageSize, offset, filter, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search Client Name V2
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchClientNameV2QuotesV2SearchClientGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<string | null>> {
      return localVarFp
        .searchClientNameV2QuotesV2SearchClientGet(query, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search Deal Name V2
     * @param {string} query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchDealNameV2QuotesV2SearchDealGet(
      query: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<string | null>> {
      return localVarFp
        .searchDealNameV2QuotesV2SearchDealGet(query, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Quote V2
     * @param {string} quoteId
     * @param {QuoteV2Update} quoteV2Update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuoteV2QuotesV2QuoteIdPut(
      quoteId: string,
      quoteV2Update: QuoteV2Update,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QuoteV2Get> {
      return localVarFp
        .updateQuoteV2QuotesV2QuoteIdPut(quoteId, quoteV2Update, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * QuotesV2Api - object-oriented interface
 * @export
 * @class QuotesV2Api
 * @extends {BaseAPI}
 */
export class QuotesV2Api extends BaseAPI {
  /**
   *
   * @summary Create Quote V2
   * @param {QuoteV2Create} quoteV2Create
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public createQuoteV2QuotesV2Post(
    quoteV2Create: QuoteV2Create,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .createQuoteV2QuotesV2Post(quoteV2Create, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Quote V2
   * @param {QuoteV2Create} quoteV2Create
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public createQuoteV2QuotesV2Post_1(
    quoteV2Create: QuoteV2Create,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .createQuoteV2QuotesV2Post_1(quoteV2Create, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This is just to get the example filter into the OpenAPI docs, not actually used
   * @summary Example Filter V2
   * @param {GetQuoteV2Filter} getQuoteV2Filter
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public exampleFilterV2QuotesV2ExampleFilterPost(
    getQuoteV2Filter: GetQuoteV2Filter,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .exampleFilterV2QuotesV2ExampleFilterPost(getQuoteV2Filter, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Quote V2
   * @param {string} quoteId
   * @param {boolean} [includeDemoData]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public getQuoteV2QuotesV2QuoteIdGet(
    quoteId: string,
    includeDemoData?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .getQuoteV2QuotesV2QuoteIdGet(quoteId, includeDemoData, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List Quotes V2
   * @param {number} [pageSize]
   * @param {number} [offset]
   * @param {string | null} [filter] Query filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public listQuotesV2QuotesV2Get(
    pageSize?: number,
    offset?: number,
    filter?: string | null,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .listQuotesV2QuotesV2Get(pageSize, offset, filter, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List Quotes V2
   * @param {number} [pageSize]
   * @param {number} [offset]
   * @param {string | null} [filter] Query filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public listQuotesV2QuotesV2Get_2(
    pageSize?: number,
    offset?: number,
    filter?: string | null,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .listQuotesV2QuotesV2Get_2(pageSize, offset, filter, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search Client Name V2
   * @param {string} query
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public searchClientNameV2QuotesV2SearchClientGet(
    query: string,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .searchClientNameV2QuotesV2SearchClientGet(query, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search Deal Name V2
   * @param {string} query
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public searchDealNameV2QuotesV2SearchDealGet(
    query: string,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .searchDealNameV2QuotesV2SearchDealGet(query, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Quote V2
   * @param {string} quoteId
   * @param {QuoteV2Update} quoteV2Update
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QuotesV2Api
   */
  public updateQuoteV2QuotesV2QuoteIdPut(
    quoteId: string,
    quoteV2Update: QuoteV2Update,
    options?: RawAxiosRequestConfig,
  ) {
    return QuotesV2ApiFp(this.configuration)
      .updateQuoteV2QuotesV2QuoteIdPut(quoteId, quoteV2Update, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
